// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoadingBar{animation-duration:4s;animation-iteration-count:infinite;animation-name:LoadingBar-moving;animation-timing-function:ease-in-out;background:rgba(0,0,0,.4);height:2px;left:0;position:fixed;top:0;width:0;z-index:10000}@keyframes LoadingBar-moving{0%{margin-left:0;width:0}25%{margin-left:0;width:100%}50%{margin-left:100%;width:0}75%{margin-left:0;width:100%}to{margin-left:0;width:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
